/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ATTRIBUTE_FIELDS = Array.from(
  { length: 20 },
  (_, i) => `Attribute${String(i + 1).padStart(2, "0")}`,
);

const CustomerProductHistoryService = {
  async getByCustomerCode(customerCode) {
    const requestScreenData = {
      url: "api/CustomerProductHistoryList",
      filter: `CustomerCode eq '${customerCode}'`,
      select: [
        "DiscountPcnt",
        "FXCurrency",
        "InvoiceNo",
        "MovementDate",
        "PriceGroupId",
        "PriceGroupShortDescription",
        "ProductCode",
        "ProductDescription1",
        "ProductCategory1",
        "ProductCategory2",
        "ProductCategory3",
        "ProductCategory4",
        "SalesOrder",
        "SalesUM",
        "SalesUMQty",
        "SalesUMStandardCost",
        "UnitPriceBase",
        "UnitPriceFX",
        "CustomerCode",
        "ExTotalBase",
        "TaxBase",
        "IncTotalBase",
        "ExTotalFX",
        "TaxFX",
        "IncTotalFX",
        "SalesUMStandardPriceBase",
        "SalesUMStandardPriceFX",
        "GrossProfitPcnt",
        "GrossProfitBase",
        ...ATTRIBUTE_FIELDS,
      ],
    };
    return await ApiService.oDataGet(requestScreenData);
  },
};

export { CustomerProductHistoryService };
